import { useState } from "react";
import axios from "axios";
import { Search, CheckCircle2, XCircle, GraduationCap } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Página pública de verificação de certificados de conclusão.
export default function VerifyCertificate() {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const verify = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    setResult(null);
    try {
      const r = await axios.get(`${API}/certificates/verify/${encodeURIComponent(code.trim())}`);
      setResult(r.data);
    } catch {
      setResult({ valid: false });
    } finally { setBusy(false); }
  };

  return (
    <section className="container-page py-16 lg:py-24" data-testid="verify-certificate-page">
      <div className="max-w-xl">
        <div className="overline">Auto-educação</div>
        <h1 className="display-heading text-4xl sm:text-5xl mt-3">Verificar certificado.</h1>
        <span className="accent-rule mt-6 block" />
        <p className="mt-5 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
          Introduza o código de verificação impresso no rodapé do certificado
          (ex.: CIEES-CERT-2026-0001) para confirmar a sua autenticidade.
        </p>
        <form onSubmit={verify} className="mt-8 flex gap-2">
          <input value={code} onChange={(e) => setCode(e.target.value)}
            placeholder="CIEES-CERT-AAAA-0000"
            className="flex-1 bg-white border border-[hsl(var(--border))] px-4 py-3 text-sm font-mono uppercase focus:outline-none focus:border-[hsl(var(--accent))]"
            data-testid="verify-code-input" />
          <button type="submit" disabled={busy} className="btn-primary disabled:opacity-60" data-testid="verify-submit">
            <Search className="h-4 w-4" /> {busy ? "…" : "Verificar"}
          </button>
        </form>

        {result && (
          result.valid ? (
            <div className="mt-8 bg-white border border-emerald-700/40 p-6" data-testid="verify-result-valid">
              <div className="flex items-center gap-2 text-emerald-800">
                <CheckCircle2 className="h-5 w-5" />
                <span className="text-sm font-medium uppercase tracking-[0.16em]">Certificado autêntico</span>
              </div>
              <div className="mt-4 space-y-1.5 text-sm">
                <p><GraduationCap className="inline h-4 w-4 mr-1.5 text-[hsl(var(--accent))]" /><strong>{result.name}</strong></p>
                <p>{result.itinerary_title} — edição {result.edition_title}</p>
                <p className="text-[hsl(var(--muted-foreground))]">{result.attended} de {result.total} sessões presenciais · emitido em {new Date(result.issued_at).toLocaleDateString("pt-PT")}</p>
              </div>
            </div>
          ) : (
            <div className="mt-8 bg-white border border-red-700/40 p-6 flex items-center gap-2 text-red-800" data-testid="verify-result-invalid">
              <XCircle className="h-5 w-5" />
              <span className="text-sm">Código não encontrado. Confirme o código e tente novamente.</span>
            </div>
          )
        )}
      </div>
    </section>
  );
}
